import { useEffect, useState, type ComponentProps } from "react"
import PlacepointLogo from "@/v1-ui/PlacepointLogo"
import { useLocation } from "@/v1-console/router/router.utils"
import Link from "@/v1-console/components/Link"
import AuthError from "@/v1-console/auth/AuthError"
import AuthLoginButton from "@/v1-console/auth/AuthLoginButton"

type AuthLoginPageProps = ComponentProps<"div">

const PAGE_BACKGROUND =
  "radial-gradient(800px 500px at 15% 10%, rgba(111,255,144,0.10), transparent 60%),"
  + "radial-gradient(700px 500px at 85% 90%, rgba(251,191,36,0.06), transparent 60%),"
  + "#07211b"

const CARD_BACKGROUND = "linear-gradient(180deg, #0e352c, #0a2a23)"

function AuthLoginPage(props: AuthLoginPageProps) {
  const [ error, setError ] = useState<Error>()
  const location = useLocation<{ error?: Error }>()
  const locationError = location.state?.error

  useEffect(() => {
    if(locationError) {
      // Prevents error from being shown after a refresh
      window.history.replaceState({}, document.title)
      setError(locationError)
    }
  }, [
    locationError
  ])

  return (
    <div
      className="auth-login-page h-screen flex items-center justify-center flex-col flex-1 pb-24 px-4"
      style={{ background: PAGE_BACKGROUND }}
      {...props}
    >
      <AuthError
        className="mb-4"
        error={error}
      />

      <div
        className="w-full p-7 rounded-2xl flex flex-col justify-center items-baseline max-w-[20rem]"
        style={{
          background: CARD_BACKGROUND,
          border: "1px solid rgba(111,255,144,0.10)",
          boxShadow: "0 30px 60px rgba(0,0,0,0.45)"
        }}
      >
        <div className="flex items-center">
          <PlacepointLogo
            className="w-10"
            fill="#6fff90"
          />

          <h1 className="ml-2 text-sm text-white">
            Placepoint
          </h1>
        </div>

        <h2 className="text-xl mt-8 mb-4 text-white">
          Logg inn
        </h2>

        <p
          className="text-sm"
          style={{ color: "rgba(221,255,229,0.65)" }}
        >
          Trykk på knappen for å logge inn. Har du ikke en konto?
          <Link
            className="auth-login__to-marketing-site ml-1"
            style={{
              color: "#6fff90",
              borderBottom: "1px solid rgba(111,255,144,0.5)"
            }}
            to="https://placepoint.no/selskap/kontakt"
          >
            Kontakt oss
          </Link>, så hjelper vi deg.
        </p>

        <AuthLoginButton
          className="mt-6 !bg-[#6fff90] hover:!bg-[#56e078] !text-[#07211b] !rounded-full !shadow-none"
        />
      </div>
    </div>
  )
}

export default AuthLoginPage
